module.exports = __webpack_public_path__ + "img/2.b71fe82b.png";